import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class ShoemakerWorkshopBuildingTileEntity extends TileEntity {
	public static readonly frameName = FrameName.SHOEMAKER;
}

export default ShoemakerWorkshopBuildingTileEntity;
